import { US_STATES } from "@/shared/constants/constants";

import type { EssentialModuleId, StateContentMap } from "@/shared/types/estateEssentials";

const stateNameMap = new Map<string, string>(US_STATES.map((s) => [s.value, s.label]));

export function getStateName(stateCode: string): string {
  return stateNameMap.get(stateCode) ?? stateCode;
}

/**
 * State-specific content per module.
 *
 * Outer key: template variable name (e.g. "state_id_requirements")
 * Inner key: state code (e.g. "CA") -> content string
 *
 * Each module ticket will populate its own entry here.
 */
export const STATE_CONTENT: Record<EssentialModuleId, StateContentMap> = {
  "cancel-passport": {},
  "notify-credit-bureaus": {},
  "mail-forwarding": {},
  "vehicle-boat-titles": {},
  "do-not-mail": {},
  "voter-registration": {},
  "social-security-benefits": {},
  "veterans-survivor-benefits": {},
};

export function getStateContent(
  moduleId: EssentialModuleId,
  stateCode: string,
): Record<string, string> {
  const moduleContent = STATE_CONTENT[moduleId];
  const result: Record<string, string> = {};

  for (const [variableKey, stateMap] of Object.entries(moduleContent)) {
    const value = stateMap[stateCode];
    if (value) {
      result[variableKey] = value;
    }
  }

  return result;
}
